<mat-menu #appMenu="matMenu" class="context-menu-container primary-menu">
  <mat-card appearance="outlined" *ngIf="user$ | async" class="p-3">
    <div mat-card-avatar class="header-image"></div>
    <mat-card-header class="context-menu-avatar-container pr-0">
      <mat-card-title>{{ (user$ | async)?.username }}</mat-card-title>
      <a
        mat-icon-button
        class="profile-icon ml-3"
        [routerLink]="[Urls.MY_DETAILS]"
      ></a>
    </mat-card-header>
  </mat-card>

  <div class="everdivider mb-3"></div>
  <a
    *ngFor="let item of menuItems$ | async"
    mat-menu-item
    [routerLink]="[item.href]"
    >{{ item.labelText }}</a
  >
  <a mat-menu-item (click)="doLogout()">Logout</a>
</mat-menu>

<button
  class="context-menu-button"
  mat-icon-button
  color="primary"
  [matMenuTriggerFor]="appMenu"
  #t="matMenuTrigger"
  [ngClass]="{ isActive: t.menuOpen }"
>
  <mat-icon>person_outline</mat-icon>
</button>
